// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MyProject from "../containers/projects/MyProject";

class Project extends Component<*> {
  render(): * {
    return (
      <UserAuth
        oneOfPrincipalList={["project"]}
        unAuthChildren={<RedirectoLogin />}
      >
        <div className="app-main">
          <MyProject match={this.props.match} />
        </div>
      </UserAuth>
    );
  }
}

export default Project;
